module.exports = __webpack_public_path__ + "media/src/images/icon__sad--4--dark-ac450ae3f39d5a51fe53a25ac1c1101c.png";